define('modules/lp_integration/views/emblue_popup',['require','exports','module','common/views/modal_layout','../models/emblue_data','./mdirector_fields_steps','../../duplicate_control/view','ldsh!../templates/emblue_popup'],function (require, exports, module) {
  'use strict';

  var ModalLayout = require('common/views/modal_layout'),
    EmBlueData = require('../models/emblue_data'),
    StepsRegion = require('./mdirector_fields_steps'),
    DuplicateControlView = require('../../duplicate_control/view');

  module.exports = ModalLayout.extend({
    template: require('ldsh!../templates/emblue_popup'),
    className: 'ed-overlay popUp-integrate',

    regions: {
      steps: '#steps',
      duplicateControl: '#duplicate_control',
    },

    events: {
      'click .js-save': 'save',
      'click .js-cancel': 'hide',
      'change #apiKey': 'changeApiKey',
    },

    i18n: {
      dropDownDefaultText: 'integration.dropdownChooseOne',
      loadingText: 'common.loadingText',
      noGroup: 'integration.noGroup',
    },

    initialize: function (options) {
      this.duplicateControlModel = this.options.duplicateControlModel;

      //get translations
      _.each(
        _.keys(this.i18n),
        function (key) {
          this.i18n[key] = $.i18n.t(this.i18n[key]);
        },
        this
      );
      this.formFields = options.formFields;
      this.integrationData = new EmBlueData({
        id: this.model.get('apiKey'),
      });
      this.regions.steps.show(
        new StepsRegion({
          model: options.model,
          collection: options.formFields,
          defaultFields: options.defaultFields,
        })
      );

      this.regions.duplicateControl.show(
        new DuplicateControlView({
          model: this.duplicateControlModel,
          noBinding: true,
        })
      );

      this.listenTo(this.integrationData, 'change:groups', this._renderGroups);
      this.listenTo(this.integrationData, 'change:fields', this._renderCustomFields);
    },

    helpers: function () {
      return {
        formFields: this.formFields.toJSON(),
        groups: this.integrationData.groups.toJSON(),
        customFields: this.integrationData.fields,
      };
    },

    save: function (e) {
      var self = this,
        fieldAssociation = {},
        apiKey = this.$('#apiKey').val(),
        groupName = this.$('#group option:selected').attr('value');
      this.$('.js-fieldmapping').each(function (index, item) {
        var pageField = $(item).data('field'),
          listField = $(item).find('select option:selected').attr('value');
        if (listField) {
          fieldAssociation[pageField.toString()] = listField;
        }
      });
      var dataToSave = {
        fields: fieldAssociation,
        apiKey: apiKey,
        config: JSON.stringify({ groupName: groupName }),
        active: true,
      };
      this.model.set(dataToSave);
      if (this.model.isValid()) {
        this.duplicateControlModel.save().then(function () {
          self.model.save(null, { patch: true });
          self.hide();
        });
      } else {
        var errors = this.model.validationError;
        _.each(
          errors,
          function (err) {
            //mark field as error
            this.$('#' + err.attribute)
              .parent()
              .addClass('has-error');
            this.$('.js-error-' + err.attribute).removeClass('hidden');
          },
          this
        );
      }
    },

    onRender: function () {
      this.$el.i18n();
      this.$('#apiKey').val(this.model.get('apiKey'));
      this.$('#apiKey').trigger('change');
      var fields = this.model.get('fields');
      //pre-select current fields
      _.each(
        _.keys(fields),
        function (pageField) {
          //find control
          var dropdown = this.$(".js-fieldmapping[data-field='" + pageField + "'] select");
          dropdown.find('option').each(function (index, item) {
            if ($(item).val() === fields[pageField]) {
              $(item).attr('selected', 'selected');
            }
          });
        },
        this
      );
      this.stopListening(this.model, 'change');
    },

    _renderGroups: function (model, listCollection) {
      var self = this,
        listEl = this.$('#group');

      listEl.empty();
      //add default one
      listEl.append($('<option />').text(this.i18n.noGroup));
      //add one per list item

      var config = self.model.get('config');
      var selectedItem = null;
      if (typeof config === 'object' && config !== null && 'groupName' in config) {
        selectedItem = config.groupName;
      }

      listCollection.each(function (list) {
        var newItem = $('<option />').attr('value', list.get('name')).text(list.get('name'));

        if (selectedItem === list.get('name')) {
          newItem.attr('selected', 'selected');
        }

        listEl.append(newItem);
      });
    },

    _renderCustomFields: function (model, fields) {
      $('.spinner').removeClass('show').addClass('hide');
      $('.noSpinner').removeClass('hide').addClass('show');

      var self = this,
        fieldLists = this.$('.js-mdirector-fields'),
        availableFields = fields;

      fieldLists.each(function (index, combo) {
        combo = $(combo);
        combo.empty();
        combo.append($('<option />').text(self.i18n.dropDownDefaultText));
        //add default fields
        _.each(availableFields, function (name) {
          var item = $('<option />').attr('value', name).text(name);
          var mappedField = self.model.get('fields')[combo.data('field')];

          if (name === mappedField) {
            item.attr('selected', 'selected');
          }
          combo.append(item);
        });
      });
    },

    _loadGroups: function () {
      var listEl = this.$('#group');
      listEl.empty();
      listEl.append($('<option />').text(this.i18n.loadingText));
    },

    changeApiKey: function (e) {
      var self = this;
      $('.noSpinner').removeClass('show').addClass('hide');
      $('.spinner').removeClass('hide').addClass('show');

      var newId = this.$(e.currentTarget).val();
      if (!newId) {
        return;
      }

      this.integrationData.id = newId;
      this._loadGroups();
      this._setupChangesPending(false);
      this.integrationData.fetch({
        success: function (model, response, options) {
          $('#apiKey').parent().removeClass('has-error');
          $('.js-error-apiKey').addClass('hidden');
          self._setupChangesPending(true);
        },
        error: function (model, xhr, options) {
          $('#apiKey').parent().addClass('has-error');
          $('.js-error-apiKey').removeClass('hidden');
        },
      });
    },
    _setupChangesPending: function (isChanged) {
      this.$('.js-save').attr('disabled', !isChanged);
    },
  });
});

